import { Cookie } from '@atlassiansox/asc-core';
import { Asap } from './models';

/**
 * Auth
 */

export type AsapAuth = {
  readonly asap: Asap;
};

export function isAsapAuth(auth: AsapAuth) {
  return !!auth.asap.issuer && !!auth.asap.keyId && !!auth.asap.privateKey;
}

export type CloudSessionTokenCookieType = {
  readonly cloudSessionTokenCookie?: Cookie;
};

/**
 * /me
 */

export type MeResponse = {
  readonly account_id: string;
  readonly name: string;
  readonly email: string;
  readonly picture: string;
  readonly locale: string;
  readonly zoneinfo: string;
};

export type WorkspaceUserType = {
  readonly display_name: string;
  readonly account_id: string;
  readonly links: Record<string, unknown>;
  readonly nickname: string;
  readonly type: string;
  readonly uuid: string;
};

export type WorkspaceType = {
  readonly name: string;
  readonly type: string;
  readonly uuid: string;
  readonly links: Record<string, unknown>;
  readonly slug: string;
};

export const CHECK_ADD_PROJECT_ACTION = 'addProduct';
export const CHECK_ADD_PROJECT_ARI_PREFIX = 'ari:cloud:platform::site/';

export type CheckAddProductCapabilitiesRequestAsap = {
  readonly auth: AsapAuth;
};

export type CheckAddProductCapabilitiesRequest = {
  readonly cloudId: string;
  readonly product: string;
  readonly licenceLimit: number;
} & CheckAddProductCapabilitiesRequestAsap;

export type CheckAddProductCapabilitiesRequestItem = {
  readonly action: string;
  readonly owner: string;
  readonly product: string;
  readonly licenceLimit: number;
};

export type CheckAddProductCapabilitiesResponse = {
  readonly capable: boolean;
  readonly resources: [
    {
      readonly resource: string;
      readonly availableLicences: number;
      readonly requiredLicences: number;
    }
  ];
};

export type CheckAuthenticationMethodsAvailableRequest = {
  readonly email: string;
  readonly application: string;
  readonly redirect_to: string;
  readonly auth: AsapAuth;
};

export type CheckAuthenticationMethodsAvailableResponse = {
  readonly account_id: string;
  readonly methods: [
    {
      readonly type: string;
      readonly redirect_to: string;
    }
  ];
};

export type UserSignupResponse = {
  readonly id: string;
};

export type PermissionsPermittedRequestAsap = {
  readonly auth: AsapAuth;
};

export type PermissionsPermittedRequestParams = {
  readonly dontRequirePrincipalInSite: boolean;
  readonly permissionId: string;
  readonly principalId: string;
  readonly resourceId: string;
};

export type PermissionsPermittedRequest = PermissionsPermittedRequestAsap &
  PermissionsPermittedRequestParams;

export type PermissionsPermittedResponse = string;

export type SignupRequestBody = {
  readonly email: string;
  readonly displayName?: string;
  readonly application: string;
  readonly redirectTo?: string;
  readonly suppressEmail?: boolean;
  readonly locale?: string;
  readonly gRecaptchaResponse?: string;
};

export type SignupRequestOptions = {
  readonly auth: AsapAuth;
};

export type GetUserUpstreamResponse = {
  name: string;
  // ...more fields exist, just not using them now
};

export type GetUsersByCloudIdRequest = {
  readonly cloudId: string;
  readonly auth: AsapAuth;
};

export type GetUsersByCloudIdResponse = {
  Resources: Array<{
    id: string;
    displayName: string;
    locale: string;
    emails: Array<{
      value: string;
      primary: true;
    }>;
  }>;
};

export type GetUserByCloudAndAaIdRequest = {
  readonly cloudId: string;
  readonly atlassianAccountId: string;
  readonly auth: AsapAuth;
};

export type GetUserByCloudAndAaIdResponseEmail = {
  readonly value: string;
  readonly type: string;
  readonly primary: boolean;
};

export type GetUserByCloudAndAaIdResponseGroup = {
  readonly value: string;
  readonly display: string;
};

export type GetUserByCloudAndAaIdResponse = {
  readonly id: string;
  readonly userName: string;
  readonly displayName: string;
  readonly title: string;
  readonly active: boolean;
  readonly timezone: string;
  readonly emails: GetUserByCloudAndAaIdResponseEmail[];
  readonly groups: GetUserByCloudAndAaIdResponseGroup[];
};
